class CardProduct extends HTMLElement {
    constructor() {
        super();
        this.cardUrl = (this.querySelector('.clickable-link').href).split('?')[0];
        // this.variants = JSON.parse(this.querySelector('#CustomVariantsScript-' + this.dataset.productId)?.textContent);

        const variantScriptElement = this.querySelector('#CustomVariantsScript-' + this.dataset.productId);
        const variantData = variantScriptElement?.textContent?.trim();

        if (variantData) {
            try {
                this.variants = JSON.parse(variantData);
            } catch (error) {
                console.error("Error parsing JSON in CardProduct:", error);
                this.variants = [];
            }
        } else {
            this.variants = [];
        }
        this.activeFilter = this.dataset.activeFilter;
    }

    connectedCallback() {
        subscribe(PUB_SUB_EVENTS.facetsUpdate, async (payload) => {
          if (payload.Search_FacetValues_String.includes('power=')) {
            const powerFilters = this.extractPowerFilters(payload.Search_FacetValues_String);
            const selectedPower = powerFilters.sort((a, b) => a - b)[0];
            this.checkAndUpdateUrl(selectedPower);
          }
        });
        if (this.activeFilter != '' && this.activeFilter) {
            this.activeFilter = parseFloat(this.activeFilter);
            this.checkAndUpdateUrl(this.activeFilter);
        }
      }
      extractPowerFilters(searchString) {
          return searchString
              .split('|')
              .filter(filter => filter.includes('power='))
              .map(filter => parseFloat(filter.split('=')[1]));
      }

      findMatchingVariant(variants, selectedPower) {
        const matchingVariant = variants.find(variant => parseFloat(variant.power) === selectedPower);
        const isAvailable = variants.find(variant => variant.available);
        if(!isAvailable) {
            return variants[0];
        }
        if(matchingVariant && matchingVariant.available) {
          return matchingVariant;
        }
        return isAvailable;
      }
      updateProductUrl(variantId) {
          const newUrl = `${this.cardUrl}?variant=${variantId}`;
          this.querySelector('.clickable-link').href = newUrl;
      }
      checkAndUpdateUrl(powerSelected) {
        const matchingVariant = this.findMatchingVariant(this.variants, powerSelected); 
        if (matchingVariant) {
            this.updateProductUrl(matchingVariant.id);
        }
      }
}

customElements.define('card-product', CardProduct);